import CssBaseline from '@mui/material/CssBaseline'
import PaidServices from './pages/PaidServices'
import './common/index.css'
import { Box, Container } from '@mui/material'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import Settings from './pages/Settings'
import Reports from './pages/Reports'
import AccessRights from './pages/AccessRights'
import StageReports from './pages/StageReports'
import RecoveryReport from './pages/RecoveryReport'
import SignedContractsReport from './pages/SignedContractsReport'
import Departments from './pages/Departments'
import ResponsibleForStages from './pages/ResponsibleForStages'
import ServicePage from './pages/ServicePage'
import AuthController from './Auth'
import ErrorModal from './components/ErrorModal'
import Replacements from './pages/Replacements'
import ReplacementsPage from './pages/ReplacementsPage'
import { SettingsLicense } from './pages/License'
import { MainLayout } from './lauouts/MainLayout'

const router = createBrowserRouter([
  {
    element: <MainLayout />,
    children: [
      {
        path: '/',
        element: <PaidServices />
      },
      {
        path: '*',
        element: <PaidServices />
      },
      {
        path: '/settings',
        element: <Settings />
      },
      {
        path: '/reports',
        element: <Reports />
      },
      {
        path: '/license',
        element: <SettingsLicense />
      },
      {
        path: '/access-rights',
        element: <AccessRights />
      },
      {
        path: '/stage-reports',
        element: <StageReports />
      },
      {
        path: '/recovery-report',
        element: <RecoveryReport />
      },
      {
        path: '/signed-contracts-report',
        element: <SignedContractsReport />
      },
      {
        path: '/departments',
        element: <Departments />
      },
      {
        path: '/responsible-for-stages',
        element: <ResponsibleForStages />
      },
      {
        path: '/service-page/:id',
        element: <ServicePage />
      },
      {
        path: '/replacements',
        element: <Replacements />
      },
      {
        path: '/new-replacement',
        element: <ReplacementsPage />
      }
    ]
  }
])

//TODO!!!!!!!!: переписать весь прооект с нуля, невозможно это поддерживать
export default function App() {
  return (
    <>
      <CssBaseline />
      <Box sx={{ backgroundColor: '#eef2f4' }}>
        <Container maxWidth={false} sx={{ minWidth: '1300px' }}>
          <AuthController>
            <Box
              sx={{ minHeight: '100vh' }}
              pb={2}
              display="flex"
              flexDirection="column"
            >
              <ErrorModal />
              <RouterProvider router={router} />
            </Box>
          </AuthController>
        </Container>
      </Box>
    </>
  )
}
